import { ModalRef, useEntityMetadataIncludeExternal, useNavigation, useTranslation } from '@msdk/common'
import { DefaultActionsDetails, EntityContext, EntityModel, FormMode, FormModel } from '@msdk/definitions'
import { ButtonIcon, IconSelector, styled, Tooltip } from '@msdk/ui'
import React from 'react'

import { ActionLabels, getEditActionLabels } from '../DynamicView/RowActions/labels-utils'
import { ActionVisualizationMode } from './action-visualization'
import { ActionMenuItem, ActionMenuText } from './ActionMenuItem'

const StyledButtonIcon = styled(ButtonIcon)`
  padding: 4px;
  margin-left: 0.8rem;
  color: ${({ theme }) => theme.palette.primary.main};
`
interface Props {
  entity: EntityContext
  formName: string
  actionDetails?: DefaultActionsDetails
  visualizationMode: ActionVisualizationMode
  modalRef?: ModalRef
  onModeChange?: (mode: FormMode, formName: string) => void
}

export function EditAction(props: Props) {
  const entityModel = useEntityMetadataIncludeExternal(props.entity.entityName, props.formName) as EntityModel
  const formModel = entityModel.getForm(props.formName) as FormModel
  const navigate = useNavigation()
  const t = useTranslation()

  const labels: ActionLabels = getEditActionLabels(props.actionDetails, t)

  const onEdit = () => {
    const form = formModel.editForm ?? entityModel.editForm ?? entityModel.defaultForm
    const id = entityModel.singleton ? props.entity.ParentId : props.entity.id

    if (props.modalRef) {
      props.onModeChange && props.onModeChange('Edit', form)
    } else {
      const ctx: Record<string, string> = { [props.entity.entityName]: id }
      const qs = new URLSearchParams()
      qs.append('mode', 'Edit')
      navigate(`${props.entity.entityName}/${form}/${id}`, undefined, ctx, qs)
    }
  }

  return (
    <>
      {props.visualizationMode === 'SingleAction' && (
        <Tooltip title={labels.description} arrow>
          <StyledButtonIcon onClick={onEdit}>
            {labels.iconTag && <IconSelector iconName={labels.iconTag} />}
            {!labels.iconTag && labels.description}
          </StyledButtonIcon>
        </Tooltip>
      )}
      {props.visualizationMode === 'MenuItems' && (
        <ActionMenuItem onClick={onEdit}>
          <IconSelector iconName={labels.iconTag} />
          <ActionMenuText>{labels.description}</ActionMenuText>
        </ActionMenuItem>
      )}
    </>
  )
}
